import { Observable } from 'rxjs';

import { ReturnCreationRequest, ReturnCreationResponse } from '../../model/return-creation.model';

export abstract class ReturnCreationAdapter {
  abstract doReturnCreation(
    request: ReturnCreationRequest
  ): Observable<ReturnCreationResponse>;
}
